export const ApiNamePaths = {
  codeMasterApi: { apiName: 'driverApiV2', apiPath: '/code-masters' },
  vehicleDriverApi: { apiName: 'driverApiV2', apiPath: '/vehicle-drivers' },
  drivesGetApi: { apiName: 'driverApi', apiPath: '/v1/drives' },
  reservationsStatus: { apiName: 'driverApi', apiPath: '/v1/reservations/status' },
  vehicleOperationScheduleApi: { apiName: 'driverApiV2', apiPath: '/vehicle-operation-schedule' },
  driverDriversApi: { apiName: 'driverApiV2', apiPath: '/drivers' },
  offeringsGetApi: { apiName: 'driverApi', apiPath: '/v1/offerings' },
  offeringsAcceptabilityApi: { apiName: 'driverApi', apiPath: '/v1/offerings/acceptability' },
  googleVehicleApi: { apiName: 'driverApi', apiPath: '/v1/vehicle-location' },
} as const;
